import { buildCandidateApplicationUrl } from "@workspace/dto/email/destinations";
import { z } from "zod";
import { buildFromAddress } from "../utils/build-email-address";
import {
  defineEmailNotificationHandler,
  requireOrganizationId,
  resolveWorkplaceName,
} from "./types";

const ApplicationSubmittedSchema = z.object({
  applicationId: z.string(),
  jobId: z.string(),
  jobTitle: z.string(),
  companyName: z.string().optional(),
});

export const applicationSubmittedHandler = defineEmailNotificationHandler({
  type: "application.submitted",
  icon: "application",
  title() {
    return "Application submitted";
  },
  description(metadata) {
    const jobTitle =
      typeof metadata.jobTitle === "string" && metadata.jobTitle.trim()
        ? metadata.jobTitle
        : undefined;
    return jobTitle
      ? `Your application for ${jobTitle} has been submitted.`
      : "Your application has been submitted.";
  },
  schema: ApplicationSubmittedSchema,
  buildNotificationPayload(data, _ctx) {
    return {
      metadata: {
        applicationId: data.applicationId,
        jobId: data.jobId,
        jobTitle: data.jobTitle,
        companyName: data.companyName,
      },
      links: {
        href: `/applications/${data.applicationId}`,
        label: "View application",
      },
    };
  },
  buildEmailPayload(
    data,
    recipient,
    { baseUrl, organizationId, unsubscribeUrl }
  ) {
    return {
      name: "email/application.submitted",
      data: {
        organizationId: requireOrganizationId({ organizationId }),
        to: recipient.email,
        from: buildFromAddress(),
        recipientName: recipient.name,
        jobTitle: data.jobTitle,
        workplaceName: resolveWorkplaceName(data.companyName),
        applicationUrl: buildCandidateApplicationUrl({
          applicationId: data.applicationId,
          baseUrl,
        }),
        unsubscribeUrl,
      },
    };
  },
});
